import { useEffect } from 'react';
import moment from 'moment';
import { TimeConvertion } from '../../utilities/utc.time.convertion';

export default function DateRangeSet({
  filterByDateCheck,
  graphFilter,
  dateRange,
  setDateRange,
  setGraphFilter,
  initialFilter,
  setApiDateRange,
  graphInfo
}) {
  // Reset filter when date filter is disabled
  useEffect(() => {
    if (!filterByDateCheck && graphFilter.filterMain === '') {
      setGraphFilter({ filterMain: initialFilter });
      setDateRange([null, null]);
    }
  }, [filterByDateCheck]);

  // Clear date range when filter changes while date filter is enabled
  useEffect(() => {
    if (
      filterByDateCheck &&
      graphFilter.filterMain !== '' &&
      dateRange.every(Boolean)
    ) {
      setDateRange([null, null]);
    }
  }, [graphFilter]);

  // Build API date range
  useEffect(() => {
    if (dateRange.every(Boolean)) {
     const formattedDateRange = dateRange.map((eachDate, index) => {
  const dateMoment =
    index === 0
      ? moment(eachDate).startOf('day')
      : moment(eachDate).startOf('day').add(1, 'day');

  if (graphInfo && graphInfo?.isSummaryGraph !== true) {
    return TimeConvertion(
      dateMoment.format('YYYY-MM-DDTHH:mm:ss')
    );
  }

  return dateMoment.format('YYYY-MM-DDTHH:mm:ss');
});


      setApiDateRange(formattedDateRange);
      setGraphFilter({ filterMain: '' });
    }

    // Restore default filter when date cleared
    if (dateRange.some((val) => val === null) && graphFilter.filterMain === '') {
      setGraphFilter({ filterMain: initialFilter });
    }
  }, [dateRange]);

  return null;
}
